import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import CashMemoDirectPreview from '../../components/pageModule/Cashmemodirects/CashMemoDirectPreview';
import { fetchCashMemoDirect, setSelected, clearCurrentCashMemoDirect } from '../../store/modules/cashmemodirect/cashmemodirectActions';

const CashmemodirectsView = () => {
    const cashmemodirectState = useSelector(state => state.cashmemodirect);
    const dispatch = useDispatch();
    const { id } = useParams();
    const isInitialized = useRef(false);
    const [isLoading, setIsLoading] = useState(false);

    const actions = {
        fetchSingle: (id) => dispatch(fetchCashMemoDirect(id)),
        setItemsSelected: (selectedRows) => dispatch(setSelected(selectedRows)),
        clearCurrent: () => dispatch(clearCurrentCashMemoDirect())
    };

    const fetchData = useCallback(async (id) => {
        try {
            setIsLoading(true);
            const data = await actions.fetchSingle(id);
            if (data && data.items) {
                const selectedIds = data.items.map(item => item?.item?.id);
                await actions.setItemsSelected({
                    key: 'itemIds',
                    data: selectedIds
                });
            }
        } catch (error) {
            console.error('Error fetching cash memo direct:', error);
        } finally {
            setIsLoading(false);
        }
    }, [actions]);

    useEffect(() => {
        if (!isInitialized.current) {
            isInitialized.current = true;
            fetchData(id);
        }
    }, [fetchData, id]);

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <CashMemoDirectPreview 
                                    data={cashmemodirectState.current}
                                    isLoading={isLoading}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CashmemodirectsView;

